module.exports = __webpack_public_path__ + "img/Become_Mentee_F.ebbfdd40.jpg";